import type {CommonDescriptionAttribute} from './CommonDescriptionAttribute';
import type {CommonFinancingPriceAttribute} from './CommonFinancingPriceAttribute';
import type {CommonMileageAttribute} from './CommonMileageAttribute';
import type {CommonPriceAttribute} from './CommonPriceAttribute';
import type {CommonPriceNoteAttribute} from './CommonPriceNoteAttribute';
import type {CommonTitleExtensionAttribute} from './CommonTitleExtensionAttribute';
import type {CommonVinAttribute} from './CommonVinAttribute';

export type VehicleMobileDePlatformAdvertisingAttribute =
  | CommonTitleExtensionAttribute
  | CommonVinAttribute
  | CommonMileageAttribute
  | CommonPriceAttribute
  | CommonFinancingPriceAttribute
  | CommonPriceNoteAttribute
  | CommonDescriptionAttribute;
